import { useContext, useState } from "react";

import {
  Context,
  clearSuccessMessage,
  clearErrorMessage,
} from "../store/student";

const useToast = () => {
  const { dispatch } = useContext(Context);

  const [toast, setToast] = useState<{
    isShow: boolean;
    type: "success" | "danger" | "";
    message: string;
  }>({
    isShow: false,
    type: "",
    message: "",
  });

  const handleToast = (
    type: "success" | "danger",
    contextStateMessage: string,
    messages: string[],
  ) => {
    if (messages.includes(contextStateMessage)) {
      setToast({
        isShow: true,
        type,
        message: contextStateMessage,
      });

      if (type === "success") {
        dispatch(clearSuccessMessage());
      } else {
        dispatch(clearErrorMessage());
      }
    }
  };

  return { toast, setToast, handleToast };
};

export default useToast;
